import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
import Categories from 'ContentUtils/constants/Categories';
import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import { DEFAULT_BUID } from '../constants/apiDefaults';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { isPortalUngatedToMigrationRpc } from '../../__generated__/chirp/com/hubspot/branding/rpc/BrandAndSiteSettingsDiffRpc';
export function fetchBrandColors(businessUnitId, ...rest) {
  const endpoint = Number.isInteger(businessUnitId) ? `branding/v1/colors/brand-kit?businessUnitId=${businessUnitId}` : 'branding/v1/colors';
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(endpoint);
}
export function fetchBranding(...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('branding/v1/data');
}
export function fetchBusinessUnit(contentType, contentId, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  const typeApiSlug = Categories[contentType] ? Categories[contentType].api_slug : contentType;
  const endpoint = contentType === Categories['blog_post'].name ? `blogs/v3/blog-posts/${contentId}` : `cospages/v2/${typeApiSlug}/${contentId}`;
  return httpClient.get(`${endpoint}?property=businessUnitId`);
}
export function fetchBrandKit(businessUnitId, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`branding/v1/brand-kit/business-unit/${isNullOrUndefined(businessUnitId) ? DEFAULT_BUID : businessUnitId}`);
}
export function fetchLogo(domain, businessUnitId, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  const query = Object.assign({}, domain && {
    domain
  }, businessUnitId && {
    businessUnitId
  });
  return httpClient.get('branding/v1/logos/logo', {
    query
  });
}
export function createLogo(logoData, query, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post('branding/v1/logos', {
    data: logoData,
    query
  });
}
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function fetchIsPortalUngatedToMigration() {
  return rpcClient.call(isPortalUngatedToMigrationRpc, {});
}
export const fetchPrimaryBrandKit = (createIfNotFound = false, ...rest) => {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('branding/v1/primary-brand-kit').catch(e => {
    if (e.status !== 404 || !createIfNotFound) {
      throw e;
    }
    return httpClient.post('branding/v1/brand-kit', {
      data: {
        name: 'My brand kit'
      }
    });
  });
};